import line_art from "../../assets/gallery/fine_arts/line_art.png";
import seat from "../../assets/gallery/fine_arts/seat.png";
import dragon_drawing from "../../assets/gallery/fine_arts/dragon_drawing.png";
import fei_cheng from "../../assets/gallery/fine_arts/fei_cheng.png";
import line_art_zoom from "../../assets/gallery/fine_arts/line_art_zoom.png";
import sutra from "../../assets/gallery/fine_arts/sutra.png";
import faces from "../../assets/gallery/fine_arts/faces.png";
import drill from "../../assets/gallery/fine_arts/drill.png";
import masked_portrait from "../../assets/gallery/fine_arts/masked_portrait.png";
import my_collection from "../../assets/gallery/fine_arts/my_collection.png";
import collage from "../../assets/gallery/fine_arts/collage.png";
import xin_jing from "../../assets/gallery/fine_arts/xin_jing.png";
import haunfield from "../../assets/gallery/fine_arts/haunfield.png";
import tulip from "../../assets/gallery/fine_arts/tulip.png";
import self_portrait from "../../assets/gallery/fine_arts/self_portrait.png";
import xingshu from "../../assets/gallery/fine_arts/xingshu.png";
import blank_space from "../../assets/gallery/fine_arts/blank_space.png";
import scene from "../../assets/gallery/fine_arts/scene.png";
import leaf_falling from "../../assets/gallery/fine_arts/leaf_falling.png";
import one_hundred from "../../assets/gallery/fine_arts/one_hundred.png";

const DataFineArts = [
	{src:line_art, name:line_art},
	{src:seat, name:seat},
	{src:dragon_drawing, name:dragon_drawing},
	{src:fei_cheng, name:fei_cheng},
	{src:line_art_zoom, name:line_art_zoom},
	{src:sutra, name:sutra},
	{src:faces, name:faces},
	{src:drill, name:drill},
	{src:masked_portrait, name:masked_portrait},
	{src:my_collection, name:my_collection},
	{src:collage, name:collage},
	{src:xin_jing, name:xin_jing},
	{src:haunfield, name:haunfield},
	{src:tulip, name:tulip},
	{src:self_portrait, name:self_portrait},
	{src:xingshu, name:xingshu},
	{src:blank_space, name:blank_space},
	{src:scene, name:scene},
	{src:leaf_falling, name:leaf_falling},
	{src:one_hundred, name:one_hundred},
]

export default DataFineArts;